import React from "react";
import { Link } from "react-router-dom";
import { Auth } from "redux-server-connection";

import "./styles.css";


//function getLocalRank(props, loggedUser) {
//  var supervisorId = "";
//  if (loggedUser.type === 1) { // Es un supervisor
//    supervisorId = loggedUser.id;
//  } else if (loggedUser.type === 2 && loggedUser.supervisor ) { // Es un vendedor supervisado
//    supervisorId = loggedUser.supervisor;
//  }
//  
//  var rank = 999;
//  var position = 0;
//  for (var i = 0; i < props.users.length; i++) {
//    var user = props.users[i];
//    if (user.type === 2 && user.supervisor === supervisorId) {
//      position++;
//    }
//    if (user.id === loggedUser.id) {
//      rank = position;
//      break;
//    }
//  }
//  return rank;
//}
//
//function getGlobalRank(props, loggedUser) {
//  var rank = 999;
//  for (var i = 0; i < props.users.length; i++) {
//    var user = props.users[i];
//    if (user.id === loggedUser.id) {
//      rank = i+1;
//      break;
//    }
//  }
//  return rank;
//}

const Render = (props, context) => {
  const user = Auth.getUser();
//  const globalRank = getGlobalRank(props, user);
//  const localRank = getLocalRank(props, user);

  return (
    <section className="backgroundHomeCard nivelUp">
      <div className="container fullHeightCalc verticalCenterFlex ">
        <div className="container clearfix">
          <div className="userAvatar horizontalCenter">
          <p className="displayBlock fullWidth white mbs horizontalCenter">Felicitaciones</p>
          <h1 class="avenirBK white horizontalCenter mbl mtn">Subiste de nivel</h1>
            {user.avatar && (
              <img
                src={`${user.avatar.icon}`}
                alt="Avatar del usuario."
                className="fullWidth horizontalCenter mbl"
              />
            )}
         
            <p className="displayBlock fullWidth mbl mtl white horizontalCenter">Ahora estas en el nivel <span className="avenirBK">X</span></p>
            <Link to="/home" className="btn btnGold mha ">
              Continuar
            </Link>
          </div>
         
        </div>
      </div>
      
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/NivelUp/Render.js